import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  // withCredentials disabled: proxy returns ACA-Origin:* which conflicts with credentials.
  // Auth is handled via Bearer token from localStorage (see interceptor below).
});

// Attach token from localStorage as a fallback
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("grabber_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export async function uploadPhoto(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload/photo", fd);
  return `${BACKEND_URL}${data.url}`;
}

export function formatApiError(detail) {
  if (detail == null) return "Noget gik galt. Prøv igen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
